import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

// Définition de la requête GraphQL pour obtenir tous les modèles de rétribution
const GET_ALL_CURRENCIES = gql`
  query ALL_CURRENCIES{
    currencies {
      code
      symbol
    }
  }
`;

const useAllCurrencies = () => {
    const { loading, error, data, refetch } = useQuery(GET_ALL_CURRENCIES, {
    fetchPolicy: "network-only",
  });

  return {
    loading,
    error,
    currencies: data?.currencies || [],
    refetch,
  };
};

export default useAllCurrencies;
